/* 

*/

export default function Logo({className, height, size, width, ...props}) {
  const defaultDimensions = size || '24px';

  return (
    <svg
      className={className || ''}
      style={
        {
          height: height || defaultDimensions,
          width: width || defaultDimensions
        }
      }
      xmlns="http://www.w3.org/2000/svg" viewBox="0 0 181.18 129.57">
      <g>
        <g>
          <path d="M129.4,0c-10.2,11.37-20.67,22.46-31.25,33.45C92.89,39,87.53,44.39,82.21,49.86L66.11,66.11,49.86,82.21C44.39,87.53,39,92.89,33.45,98.15,22.46,108.73,11.37,119.21,0,129.4,10.19,118,20.67,106.94,31.25,96,36.51,90.42,41.87,85,47.19,79.54l16.1-16.25,16.25-16.1C85,41.87,90.43,36.51,96,31.25,106.94,20.68,118,10.2,129.4,0Z" />
          <path d="M27.5,0C38.87,10.2,50,20.68,61,31.25c5.52,5.26,10.94,10.62,16.41,15.94l16.25,16.1,16.1,16.25C115,85,120.39,90.42,125.65,96c10.58,11,21.06,22.08,31.25,33.45-11.37-10.19-22.46-20.67-33.45-31.25-5.53-5.26-10.94-10.62-16.41-15.94L90.79,66.11,74.69,49.86C69.37,44.39,64,39,58.75,33.45,48.18,22.46,37.7,11.37,27.5,0Z" />
          <path d="M181.18.17C171,11.54,160.5,22.62,149.93,33.62,144.67,39.14,139.3,44.56,134,50l-16.1,16.25-16.25,16.1c-5.47,5.31-10.89,10.68-16.41,15.94-11,10.58-22.08,21.05-33.45,31.25C62,118.2,72.45,107.1,83,96.11,88.28,90.59,93.65,85.17,99,79.7l16.1-16.25,16.26-16.09c5.47-5.32,10.89-10.68,16.41-15.94C158.72,20.84,169.81,10.36,181.18.17Z" />
        </g>
      </g>
    </svg>
  );
};
